import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadAllInvoices: ['partner'],
  loadAllInvoicesSuccess: ['data'],
  resetAllInvoices: [],
  loadInvoice: ['partner', 'invoice'],
  loadInvoiceSuccess: ['data'],
  loadInvoiceTransaction: ['partner', 'invoice'],
  loadInvoiceTransactionSuccess: ['transaction'],
  resetInvoice: [],
  addInvoice: ['partner', 'data'],
  addInvoiceSuccess: [],
  cancelInvoice: ['partner', 'invoice'],
  exportInvoices: ['partner', 'param'],
  exportInvoicesSuccess: []
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  all: {
    adding: false,
    exporting: false,
    loading: true,
    data: {
      total: 0,
      start: 0,
      sort: null,
      remaining: 0,
      order: 'asc',
      entries: [],
      count: 0
    }
  },
  single: {
    loading: true,
    data: {
      items: [],
      partner: {},
      customer: {},
      transaction: {}
    }
  }
});

const loadAllInvoicesSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    loading: false,
    data: action.data
  }
});

const addInvoice = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    adding: true
  }
});

const addInvoiceSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    adding: false
  }
});

const resetAllInvoices = (state, action) => ({
  ...state,
  all: INITIAL_STATE.all
});

const loadInvoiceSuccess = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    loading: false,
    data: action.data
  }
});

const loadInvoiceTransactionSuccess = (state, action) => ({
  ...state,
  single: {
    ...state.single,
    loading: false,
    transaction: action.transaction
  }
});

const resetInvoice = (state, action) => ({
  ...state,
  all: INITIAL_STATE.single
});

const exportInvoices = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    exporting: true
  }
});

const exportInvoicesSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    exporting: false
  }
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_ALL_INVOICES]: resetAllInvoices,
  [Types.LOAD_ALL_INVOICES_SUCCESS]: loadAllInvoicesSuccess,
  [Types.RESET_ALL_INVOICES]: resetAllInvoices,
  [Types.LOAD_INVOICE]: resetInvoice,
  [Types.LOAD_INVOICE_SUCCESS]: loadInvoiceSuccess,
  [Types.LOAD_INVOICE_TRANSACTION]: resetInvoice,
  [Types.LOAD_INVOICE_TRANSACTION_SUCCESS]: loadInvoiceTransactionSuccess,
  [Types.RESET_INVOICE]: resetInvoice,
  [Types.ADD_INVOICE]: addInvoice,
  [Types.ADD_INVOICE_SUCCESS]: addInvoiceSuccess,
  [Types.EXPORT_INVOICES]: exportInvoices,
  [Types.EXPORT_INVOICES_SUCCESS]: exportInvoicesSuccess
});
